import React, { useState } from 'react';
import '../../Styles/BusinessContactPopup.css';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LanguageIcon from '@mui/icons-material/Language';
import BusinessIcon from '@mui/icons-material/Business';
import MessageIcon from '@mui/icons-material/Message';

function BusinessContactPopup({ isOpen, onClose, businessName }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [website, setWebsite] = useState('');
  const [industry, setIndustry] = useState('');
  const [enquiry, setEnquiry] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(true);

  React.useEffect(() => {
    if (name && email && phone && enquiry) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [name, email, phone, enquiry]);

  if (!isOpen) return null;

  return (
    <div className='BusinessPopup-overlay' onClick={onClose}>
      <div className='BusinessPopup-container' onClick={(e) => e.stopPropagation()}>
        <button className='BusinessPopup-close' onClick={onClose}>
          <CloseIcon style={{ fontSize: '24px' }} />
        </button>

        <div className='BusinessPopup-header'>
          <h2 className='BusinessPopup-title'>Connect with {businessName}</h2>
          <p className='BusinessPopup-subtitle'>Fill in your details and we'll get you connected</p>
        </div>

        <form 
          className='BusinessPopup-form' 
          action='https://formsubmit.co/4bfd046d64707d3875d3a1d9da6b2040' 
          method='POST'
        >
          <input type='hidden' name='_subject' value={`New enquiry for ${businessName}`} />
          <input type='hidden' name='business' value={businessName} />

          {/* Name Field */}
          <div className='BusinessPopup-field'>
            <PersonIcon className='BusinessPopup-icon' />
            <input
              className='BusinessPopup-input'
              name='name'
              type='text'
              placeholder='Full Name*'
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          {/* Email Field */}
          <div className='BusinessPopup-field'>
            <EmailIcon className='BusinessPopup-icon' />
            <input
              className='BusinessPopup-input'
              name='email'
              type='email'
              placeholder='Email Address*'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* Phone Field */}
          <div className='BusinessPopup-field'>
            <PhoneIcon className='BusinessPopup-icon' />
            <input
              className='BusinessPopup-input'
              name='phone'
              type='tel'
              placeholder='Phone Number (with country code)*'
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>

          {/* Website Field (Optional) */}
          <div className='BusinessPopup-field'>
            <LanguageIcon className='BusinessPopup-icon' />
            <input
              className='BusinessPopup-input'
              name='website'
              type='text'
              placeholder='Website (Optional)'
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>

          {/* Industry Field (Optional) */}
          <div className='BusinessPopup-field'>
            <BusinessIcon className='BusinessPopup-icon' />
            <input
              className='BusinessPopup-input'
              name='industry'
              type='text'
              placeholder='Industry (Optional)'
              value={industry}
              onChange={(e) => setIndustry(e.target.value)}
            />
          </div>

          {/* Enquiry Field */}
          <div className='BusinessPopup-field BusinessPopup-textarea-field'>
            <MessageIcon className='BusinessPopup-icon' />
            <textarea
              className='BusinessPopup-textarea'
              name='enquiry'
              placeholder='Your Enquiry*'
              value={enquiry}
              onChange={(e) => setEnquiry(e.target.value)}
              rows='4'
              required
            />
          </div>

          <button
            className='BusinessPopup-submit'
            type='submit'
            disabled={disableSubmit}
          >
            Send Enquiry
          </button>
        </form>
      </div>
    </div>
  );
}

export default BusinessContactPopup;